import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Pages/Home';
import About from './Pages/About';
import Music from './Pages/Music';
import Portfolio from './Pages/Photographies/Portfolio';
import Contact from './Pages/Contact';
import Capitals from './Pages/Photographies/Capitals';
import Architecture from './Pages/Photographies/Architecture';
import Fashion from './Pages/Photographies/Fashion';
import Portraits from './Pages/Photographies/Portraits';
import Reportage from './Pages/Photographies/Reportage';
import Photography from './Pages/Photography';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import WallTextures from './Pages/Photographies/WallTextures';
import Ukraine2022 from './Pages/Photographies/Ukraine2022';
import Pahf from './Pages/Photographies/PostApocalypticHighFashion';
import Events from './Pages/Events';
import PrintsForSale from './Pages/Photographies/Prints';
import UntitledBodyProject from './Pages/Photographies/untitledbodyproject';
import Bern2025 from './Pages/Photographies/Bern2025';
import Immersion from './Pages/Photographies/Immersion';
import Writing from './Pages/Writing';
import ChereAmie_1 from './Pages/Writing/ChereAmie_1';
import ScrollToTop from './ScrollToTop';  // ← added

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />   {/* ← added */}
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/about' element={<About />} />
        <Route path='/music' element={<Music />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/events' element={<Events />} />

        <Route path='/ph' element={<Photography />} />
        <Route path='/ph/capitals2023' element={<Capitals />} />
        <Route path='/ph/untitledbodyproject' element={<UntitledBodyProject />} />
        <Route path='/ph/architecture' element={<Architecture />} />
        <Route path='/ph/architecture/walltextures' element={<WallTextures />} />
        <Route path='/ph/fashion' element={<Fashion />} />
        <Route path='/ph/pahf' element={<Pahf />} />
        <Route path='/ph/portraits' element={<Portraits />} />
        <Route path='/ph/reportage' element={<Reportage />} />
        <Route path='/ph/ukraine2022' element={<Ukraine2022 />} />
        <Route path='/ph/portfolio2024.pdf' element={<Portfolio />} />
        <Route path='/ph/bern2025' element={<Bern2025 />} />
        <Route path='/ph/immersion_i-iii' element={<Immersion />} />
        <Route path='/ph/prints' element={<PrintsForSale />} />

        <Route path='/writing' element={<Writing />} />
        <Route path='/writing/chereamie_1' element={<ChereAmie_1 />} />

        <Route path='*' element={<Home />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
